// config for screensize thresholds and settings
var config = {
    multiSize: {
        large: 1250,
        medium: 650,
        small: 300
    }
};


/**
 * Multi-size graphics
 * These allow us to load the relevant image size, depending on the size of the screen
 * By default we load a mobile-sized image initially, and swap to larger pics if applicable
 **/
function ResponsiveBG(){

    $('.responsive-bg').each( function( key, panel ){

        panel = $(panel);
        var panelWidth = $(window).outerWidth();
        
        if( panelWidth > config.multiSize.large && panel.data('large') ){
            if( panel.is( 'img') ) {
                panel.delay(1000).attr( 'src', panel.data('large') );
            } else {
                panel.delay(1000).css({ 'background-image': 'url('+ panel.data('large') +')' });
            }
            
        }else if( panelWidth > config.multiSize.medium && panel.data('medium') ){
            if( panel.is( 'img') ) {
                panel.attr( 'src', panel.data('medium') );
            } else {
                panel.css({'background-image': 'url('+ panel.data('medium') +')' });
            }
            
        }else if(panel.data('small')){
            if( panel.is( 'img') ) {
                panel.attr( 'src', panel.data('small') );
            } else {
                panel.css({'background-image': 'url('+ panel.data('small') +')' });
            }

        }

        panel.removeClass('loading');

    });

}

function Triangles() {

    var triWidth = $('.page-background .triangles, footer .triangles').width();
    var triHeight = triWidth * 0.30;
    var headerHeight = $('header').outerHeight(true);

/*    
    console.log('width ' + triWidth); // 1903
    console.log('height ' + triHeight); // 650
    console.log('header ' + headerHeight); // 140
*/

    // Page header
    // if( $('.HomePage').length != 1 ) {
    //     $('.page-background .triangles').height(triHeight + 'px');      // 650
    //     $('.page-background').height( headerHeight + triHeight + 'px');     // 800
    //
    //     if( $(window).width() > 1025 ) {
    //         // For ipad landscape and bigger
    //         $('main .inner section.intro').css('padding-top', (triHeight - headerHeight) / 2 + 'px');    // 250
    //
    //     } else {
    //         // For ipad landscape and smaller
    //         $('main .inner section.intro').css('padding-top', triHeight / 2 + 'px');    // 250
    //     }
    //
    // }

    // Page footer
    // $('footer .triangles').height(triHeight);
    // $('footer .inner').css('padding-top', triHeight * .8 + 'px');
}

function HomeTriangles() {
    if( $('.HomePage').length > 0 ) {

        var triWidth = $('.HomePage .page-background .triangles').width();
        var triHeight = triWidth * 0.20;
        var headerHeight = $('header').outerHeight();

        $('.HomePage .page-background .triangles').height(triHeight + 'px');
        $('.HomePage .page-background').height( headerHeight + (triHeight / 2) + 'px');
        $('.HomePage header').css('margin-bottom', (triHeight / 2) + 'px');

    }
}

function Hexagons() {

    $('.hexagon.logo').each( function() {
        var hexWidth = $(this).width();
        var hexHeight = hexWidth * 1.15;
        $(this).height(hexHeight);
    });

}

function MainNav() {

    $('#mob-icon').click(function() {
        $(this).toggleClass('open');
        $('.nav-panel').toggleClass('active');
        
    });
    
}

function InvestmentsFilter() {

    if( $('.HolderPage').length > 0 ) {

        var pageURL = window.location.href;
        var hasFilter = '';

        if( pageURL.indexOf("filter") > -1 ) {
            hasFilter = true;        
        } else {
            hasFilter = false;            
        }

        $('#Form_FilterForm .checkbox input, #Form_FilterForm select').change(function() {

            var form = $(this).closest('form');
            var data = form.serialize();

            var params = data.split('&');
            params = params.slice(0,-1); // remove security id (last element in array)

            var str = 'filter';

            $.each(params, function(index, item) {
                var parts = item.split('=');
                
                if(parts[0] == 'Category' ) {
                    if( parts[1] == '') {
                        str += '/all';
                    } else {
                        str += '/' + parts[1];
                    }
                }

                if(parts[0] == 'Studies' && parts[1] != '') {
                    str += '/' + parts[1];
                }

                if(hasFilter) {
                    // replace filter properties in current url
                    plainURL = pageURL.substring(0, pageURL.indexOf('filter/'));
                    window.location.href = plainURL + str;

                } else {
                    window.location.href = pageURL + str;
                }

            });            
        });

    }

}

function StaffBios() {

    if( $('.person').length > 0 ) {

        $('.person').click(function() {

            // on click of person, get href
            var href = $(this).attr('data-name');

            // get relevant .text from .bio-text based on id
            var selectedBio = $('.bio-text .text#' + href).clone();
            
            // Get closest .bios div
            var bioDiv = $(this).parent('.row').next('.bios');

            // clear any existing contents
            bioDiv.empty();
            // insert into person's closest .bios
            bioDiv.append(selectedBio);
            // show .bios div
            if( bioDiv.not(':visible') ) {
                bioDiv.slideDown(500);
            }

            // Close other .bios div
            $('.profiles .bios').not(bioDiv).slideUp(500);
            
            // show .person's .arrow
            $('.person').removeClass('active');
            $(this).addClass('active');

        });

    }
}

function StaffHexagons() {

    var hexWidth = $('.person .hexagon').width();
    var hexHeight = hexWidth * 1.15;

    $('.person .hexagon').height(hexHeight);
    $('.person').css('min-height', hexHeight + 50 + 'px');

}

function ModuleSlider() {
    if( $('.module.slider').length > 0 ) {

        // click on nav overrides timer
        $('.module.slider .slidenav span.hexagon').click(function(){
            changeSlides( 'click', $(this).index() );
            clearInterval( setSliderTimer );
        })


        /* --- CHANGE SLIDES --- */

        function changeSlides( mode, destination ){

            // if no destination specified
            if( mode == 'click' ){
                nextSlide = destination;
            } else {
                // if at last element
                if( currentSlide == numSlides ){
                    nextSlide = 0;
                } else {
                    nextSlide = currentSlide + 1;
                }
            }

            // update activated controls
            $('.module.slider .slidenav span.hexagon').removeClass('active');
            $('.module.slider .slidenav span.hexagon:eq(' + nextSlide + ')').addClass('active');


            // --- UPDATE SLIDER

            // move all to bottom
            $('.module.slider .study').css({ 'z-index' : 1, 'opacity': 1 });

        /*    // move current on top of bottom stack
            $('.module.slider .study:eq(' + currentSlide + ')').css({ 'z-index' : 2, 'opacity': 0 });*/

            // move destination to top with 0% opacity and then animate in
            $('.module.slider .study:eq(' + nextSlide + ')').css({ 'z-index' : 3 }).animate({ 'opacity' : 1 }, 700);


            // --- UPDATE COUNTER
            currentSlide = nextSlide;

        }

        // set timer (provided elements exist)
        if( $('.module.slider').length != 0 ){

            // number of slides
            var numSlides = $('.module.slider .study').length - 1;

            // current slider
            var currentSlide = numSlides;

            // declare variable
            var nextSlide = 1;

            // run function on load
            changeSlides( 'timer' );

            // initiate timed slide
            // var setSliderTimer = setInterval( changeSlides, 7000 );
        }


    }
}

function ModuleImagePullOut() {
    if( $('.module.image .white-background').length > 0 ) {

        $('.module.image .white-background').each(function() {
            var totalH = 0;

            $(this).children().each(function() {
                totalH = totalH + $(this).outerHeight(true);
            });

            $(this).height(totalH);

        });
    }
}

/*
    Resize the height of bg poly with the changing height of the 2nd module on the homepage
 */
function HomePageAnglePoly() {
    if( $('.HomePage').length > 0 ) {
        // get the height of the 2nd module and apply it to the polygon and main
        var modHeight = $('.module:eq(1)').outerHeight();
        if( modHeight > 800 ) {
           $('.polygon-bg.vertical-center').height(modHeight + 'px');
           $('.HomePage.main.first').css('min-height', modHeight + 'px');
        }
    }
}

function InvestorSectionAccordian() {
    if( $('.InvestorSection').length > 0 ) {

        $('.documentsets-set h3').click(function() {

            if( $(this).hasClass('open') ) {
                // close clicked
                $(this).removeClass('open');
                $(this).siblings('.documents').slideUp();

            } else {
                // Close others
                $('.documentsets-set .documents').slideUp();
                $('.documentsets-set h3').removeClass('open');

                // Open clicked
                $(this).addClass('open');
                $(this).siblings('.documents').slideDown();
            }
        });
    }
}

$(document).ready( function() {
    
    ResponsiveBG();
    Triangles();
    HomeTriangles();
    Hexagons();
    MainNav();
    InvestmentsFilter();
    StaffBios();
    StaffHexagons();
    ModuleSlider();
    ModuleImagePullOut();
    HomePageAnglePoly();
    InvestorSectionAccordian();

    $(window).resize( function() {
        ResponsiveBG();
        Triangles();
        HomeTriangles();
        Hexagons();
        HomePageAnglePoly();
        StaffHexagons();
        ModuleImagePullOut();
    });

});
